module.exports = __webpack_public_path__ + "img/Charles Johnson.efbab94a.jpg";